import React from "react";
import { auth } from "../firebase/firebase";

interface NavbarProps {
  user: firebase.User;
  isAdmin?: boolean;
  onUploadClick?: () => void;
}

const NavbarMy = ({ user, isAdmin, onUploadClick }: NavbarProps) => {
  return (
    <nav className="bg-white border-b border-zinc-200 px-4 py-3">
      <div className="max-w-6xl mx-auto flex items-center justify-between">
        <div className="flex items-center">
          <img 
            src="/ogle-logo.png" 
            alt="Ogle Logo" 
            className="w-36 h-auto"
          />
        </div>
        
        <div className="flex items-center gap-3">
          {isAdmin && onUploadClick && (
            <button
              onClick={onUploadClick}
              className="inline-flex items-center justify-center h-10 px-4 rounded-lg bg-zinc-200 hover:bg-zinc-300 text-zinc-800  font-semibold text-sm transition-colors gap-2"
            >
              <svg 
                width="16" 
                height="16" 
                viewBox="0 0 24 24" 
                fill="none" 
                xmlns="http://www.w3.org/2000/svg"
                className="stroke-current"
              >
                <path 
                  d="M12 5v14M5 12h14" 
                  stroke="currentColor" 
                  strokeWidth="2" 
                  strokeLinecap="round" 
                  strokeLinejoin="round"
                />
              </svg>
              Pievienot
            </button>
          )}
          
          <button
            onClick={() => auth.signOut()}
            className="inline-flex items-center justify-center h-10 px-4 rounded-lg bg-zinc-700 hover:bg-zinc-950 text-white  font-semibold text-sm transition-colors"
          >
            Iziet
          </button>
        </div>
      </div>
    </nav>
  );
};

export default NavbarMy;
